import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

export const signOut = async () => {
  const response: AxiosResponse = await HttpService.post('auth/signout', null);

  return response.data;
};
